import { useIsPlanInactive } from "@/hooks/useIsPlanInactive";
import { Route } from "@/paths";
import { Anchor, Group } from "@mantine/core";
import { useMemo } from "react";
import { MdOutlineArrowForward } from "react-icons/md";
import { Link } from "react-router-dom";
import { LayoutWorkstationHeader } from "../_layouts/LayoutWorkstationHeader/LayoutWorkstationHeader";

export const TrialEndWarning = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const { isPlanInactive } = useIsPlanInactive();
  const childrenMemo = useMemo(() => children, [children]);

  const alertText =
    "Your plan has expired. You are in read-only mode. See our pricing page to continue your subscription.";

  if (!isPlanInactive) return children;

  return (
    <LayoutWorkstationHeader
      header={
        <Group
          gap={4}
          w={"100dvw"}
          h={40}
          bg={"pink.2"}
          justify={"center"}
          align={"center"}
        >
          <Anchor underline="always" component={Link} to={Route.Pricing} inline>
            {alertText}
          </Anchor>
          <MdOutlineArrowForward />
        </Group>
      }
    >
      {childrenMemo}
    </LayoutWorkstationHeader>
  );
};
